// Captures Android/Chrome's beforeinstallprompt as early as possible (on import)
// so the install tip can trigger the native prompt later.
let deferredPrompt = null;

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new Event("pwa-installable"));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
  });
}

export const getDeferredPrompt = () => deferredPrompt;
export const clearDeferredPrompt = () => { deferredPrompt = null; };
